export enum AvailabilitiesDistributionSortEnum {
  sf = 'sf',
  recordCount = 'record_count',
}
